import React from "react";
import { AiEyeIconStyle as S } from "./AiEyeIcon.style";
import { useClassNames } from "hooks/useClassNames";

export interface AiEyeIconProps {
  className?: string;
  isLooping?: boolean;
  size?: "large" | "normal" | "small";
}

export const AiEyeIcon: React.FC<AiEyeIconProps> = ({ className, isLooping, size }) => {
  const classNames = useClassNames(
    {
      "ai-eye-icon-large": size === "large",
      "ai-eye-icon-normal": !size || size === "normal",
      "ai-eye-icon-small": size === "small",
    },
    className,
  );
  return (
    <S.AiEyeIcon className={classNames} isLooping={isLooping}>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <g clipPath="url(#clip0_328_3131)">
          <rect x="20" y="20" width="20" height="20" rx="10" transform="rotate(180 20 20)" fill="#CFB80E" />
          <path
            d="M22.2074 12.9687C22.2074 12.9687 8.17919 24.0259 -2.39591 7.83725C-2.39591 7.83725 12.0008 -2.65579 22.2074 12.9687Z"
            fill="white"
          />
          <g style={{ mixBlendMode: "multiply" }}>
            <path
              id="iris"
              d="M2.90899 -0.0144566C-0.874352 3.11335 -1.41112 8.70526 1.71008 12.4754C4.83129 16.2456 10.4285 16.7663 14.2119 13.6385C17.9952 10.5107 18.532 4.91878 15.4108 1.14862C12.2896 -2.62154 6.69232 -3.14227 2.90899 -0.0144566Z"
              fill="#EF94E1"
            />
          </g>
          <g style={{ mixBlendMode: "color-burn" }}>
            <path
              id="pupil"
              d="M3.12622 6.60243C1.12659 8.25559 0.842891 11.2111 2.49256 13.2038C4.14222 15.1964 7.10056 15.4717 9.10019 13.8185C11.0998 12.1653 11.3835 9.20982 9.73385 7.21716C8.08419 5.22449 5.12585 4.94927 3.12622 6.60243Z"
              fill="#EF94E1"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_328_3131">
            <rect x="20" y="20" width="20" height="20" rx="10" transform="rotate(180 20 20)" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </S.AiEyeIcon>
  );
};
